interface WeekNavProps {
  weekLabel: string;
  onPrevWeek: () => void;
  onNextWeek: () => void;
  onThisWeek: () => void;
  isCurrentWeek: boolean;
  canGoNext: boolean;
}

/**
 * Thursday-anchored week navigation — prev/next/"this week" plus the current range label. Shared
 * between the checklist (`ChecklistHeader`) and the boss matrix (WP6) so the two screens' week
 * pickers behave identically instead of drifting apart.
 */
export function WeekNav({
  weekLabel,
  onPrevWeek,
  onNextWeek,
  onThisWeek,
  isCurrentWeek,
  canGoNext,
}: WeekNavProps) {
  return (
    <div className="flex items-center justify-between gap-3">
      <div className="flex items-center gap-1">
        <button
          type="button"
          onClick={onPrevWeek}
          aria-label="Previous week"
          className="flex min-h-tap min-w-tap items-center justify-center rounded-lg text-text-muted transition-colors hover:bg-bg-elevated-hover hover:text-text"
        >
          ‹
        </button>
        <button
          type="button"
          onClick={onNextWeek}
          disabled={!canGoNext}
          aria-label="Next week"
          className="flex min-h-tap min-w-tap items-center justify-center rounded-lg text-text-muted transition-colors hover:bg-bg-elevated-hover hover:text-text disabled:opacity-30"
        >
          ›
        </button>
        <span className="ml-2 text-sm font-semibold tabular-nums text-text">{weekLabel}</span>
      </div>
      {!isCurrentWeek && (
        <button
          type="button"
          onClick={onThisWeek}
          className="min-h-tap rounded-lg px-3 text-sm font-semibold text-accent transition-colors hover:bg-accent-dim"
        >
          This week
        </button>
      )}
    </div>
  );
}
